module.exports = __webpack_public_path__ + "static/media/pinball.2542f4cf.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/pinball.gif
// module id = 498
// module chunks = 0